import styled from "styled-components";

export default styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  background-color: Transparent;
  color: #fff;
  margin: 5px;
  font-size: 1em;
`;